import React from "react";

function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="33"
      viewBox="0 0 35 33"
    >
      <g
        id="Group_27177"
        data-name="Group 27177"
        transform="translate(6660 23288)"
      >
        <rect
          id="Rectangle_11971"
          data-name="Rectangle 11971"
          width="35"
          height="33"
          transform="translate(-6660 -23288)"
          fill="#596970"
          opacity="0"
        />
        <path
          id="Path_18515"
          data-name="Path 18515"
          d="M16.758,8.346l5.9,5.9L8.9,28H3V22.1Zm1.965-1.965,2.948-2.948a1.39,1.39,0,0,1,1.965,0l3.931,3.931a1.39,1.39,0,0,1,0,1.965l-2.948,2.948Z"
          transform="translate(-6658 -23287.025)"
          fill="#596970"
        />
      </g>
    </svg>
  );
}

export default EditIcon;
